// extracted by mini-css-extract-plugin
export default {"exit":"styles_exit__GHNaO","close":"styles_close__AfLdP","arrow":"styles_arrow__ehYg8"};